// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2tEo8","rightAdornment":"Header_rightAdornment__ARYp1"};